import { createContext } from "react";

import { IGatewaysContext } from "./gateways-context.interface";

export const GatewaysContext = createContext<IGatewaysContext>(
  {} as IGatewaysContext
);
